import { registerLocaleData } from "@angular/common";
import localePt from "@angular/common/locales/pt";
import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { LOAD_WASM } from "ngx-scanner-qrcode";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

let user: { Theme?: string } | null = null;
try {
  const rawUser = localStorage.getItem("pede-mais-garcom-user");
  user = rawUser ? JSON.parse(rawUser) : null;
} catch {
  user = null;
}

const $html = document.querySelector("html");
$html?.classList.toggle("dark-mode", user?.Theme === "dark-mode");

registerLocaleData(localePt, "pt-BR");

function bootstrapApp() {
  bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err),
  );
}

LOAD_WASM("assets/wasm/ngx-scanner-qrcode.wasm").subscribe({
  next: () => bootstrapApp(),
  error: (err) => {
    console.error("ngx-scanner-qrcode WASM failed to load", err);
    bootstrapApp();
  },
});
